import React, { useEffect, useMemo } from "react";
import styles from "./tax.module.css";
import Indanegas from "../../assets/Indane.png";
import hpgas from "../../assets/Hp.png";
import bharatgas from "../../assets/Bharatgas.png";
import { useSelector } from "react-redux";
import moment from "moment";
import useAmountToWords from "../../utils/Hook/useAmountToWords";
import { CheckBox } from "./../inputs/CheckBox";
import { get_bank_master_list } from "../../screens/MasterData/masterdataSlice";
import store from "../../redux/store";

const TaxInvoice3 = React.memo(
  ({
    previewRef,
    table_header,
    table_body,
    empty_arr_length = 8,
    listdata,
    net_total,
    irn = false,
    Total_tax,
    taxable_amt,
    igst,
    cgst,
    sgst,
    other,
    empty_row_height,
    view,
    doc_name = "TAX INVOICE",
    doc_type = "",
    bank = true,
    other_data,
    ship_to = true,
    upi = true,
  }) => {
    const { profile_data, seal_image, signature_image, upi_qr_image, upi_id } =
      useSelector((state) => state.profile);

    const { bank_master_list } = useSelector((state) => state.masterdata);
    const bank_data = bank_master_list?.filter((v) => v?.DA_STATUS == "1");

    useEffect(() => {
      store.dispatch(get_bank_master_list());
    }, []);

    // console.log("data time invoice ===",moment(new Date()).format("DD/MM/YYYY hh:mm:ss.SSS"));
    // console.log("irn_qr ===", listdata?.irn_qr);

    const convertAmountToWords = useAmountToWords(
      Number(net_total || 0).toFixed(0)
    );
    // const convertAmountToWords_Total_tax = useAmountToWords(Total_tax);
    const { omc_name } = useSelector((state) => state.other);

    return (
      <div
        // id="printable-content"
        style={{
          marginLeft: view ? 0 : "",
          width: view ? "100%" : "",
          paddingRight: !view ? "4rem" : "",
          // letterSpacing: "-1px",
          wordSpacing: "-1.2px", // Adjust this value as needed
        }}
        className={styles.invoice_main}
        ref={previewRef}
      >
        {/* Same in all */}
        <div>{listdata?.irn_qr}</div>
        <>
          <div
            style={{
              textAlign: "center",
              fontSize: "18px",
              fontWeight: "bold",
              padding: "0 0",
              marginBottom: "1rem",
            }}
          >
            {doc_name}
          </div>

          <div
            style={{
              width: "100%",
              fontSize: "14px",
              textAlign: "right",
              padding: "0 2rem 5px 0",
              display: "flex",
              justifyContent: "flex-end",
              gap: "0.5rem", // Add some space between items
            }}
          >
            <label style={{ display: "flex", alignItems: "center" }}>
              <CheckBox /> Original
            </label>
            /
            <label style={{ display: "flex", alignItems: "center" }}>
              <CheckBox /> Duplicate
            </label>
            /
            <label style={{ display: "flex", alignItems: "center" }}>
              <CheckBox /> Triplicate
            </label>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "1rem",
              gap: "1rem",
            }}
          >
            <div
              style={{
                flex: 1,
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "flex-start",
              }}
            >
              <img
                id="Aname"
                style={{ maxWidth: "170px", objectFit: "contain" }}
                src={
                  omc_name == "IOCL"
                    ? Indanegas
                    : omc_name == "HPCL"
                      ? hpgas
                      : omc_name == "BPCL"
                        ? bharatgas
                        : ""
                }
              />
            </div>

            <div
              style={{
                flex: 6,
                gap: ".25rem",
                // marginLeft: !irn ? "" : "",
                paddingRight: !irn ? ".5rem" : "",
                flexDirection: "column",
                display: "flex",
                alignItems: "flex-start",
                width: "100%",
                fontSize: "14px",
              }}
            >
              <div style={{ fontWeight: "bold", fontSize: "15px" }}>
                {profile_data?.name?.toUpperCase()}
              </div>
              <div
              // style={{ maxWidth: "550px" }}
              >
                {profile_data.ADDRESS}, {profile_data?.LOCATION},{" "}
                {profile_data.DISTRICT}, {profile_data.state_name} ,
                {profile_data?.PINCODE},
              </div>
              <div>
                PH:{profile_data?.mobile},{profile_data?.landline} E-Mail :
                {profile_data?.email}
              </div>
              {/* <div>
                PH:{profile_data?.mobile},{profile_data?.landline}
              </div> */}
              <div></div>
              <div> GSTIN/UIN: {profile_data?.gst}</div>
            </div>

            <div
              style={{
                flex: 1,
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              {irn && (
                <img
                  id="Aname"
                  style={{
                    maxWidth: "100px",
                    height: "100px",
                    objectFit: "cover",
                  }}
                  src={listdata?.irn_qr}
                />
              )}
            </div>
          </div>
        </>

        {doc_type == "CN" || doc_type == "DN" ? (
          <table className={styles.table_1}>
            <tr>
              <td>
                {doc_type == "CN" ? "CREDIT NOTE" : "DEBIT NOTE"} NO :{" "}
                {listdata?.SR_NO}
              </td>
              <td>REF INV NO : {listdata?.REF_NUMBER || "NA"}</td>
              <td>TYPE : {listdata?.type || "NA"}</td>
            </tr>
            <tr>
              <td>
                {doc_type == "CN" ? "CREDIT NOTE" : "DEBIT NOTE"} DATE :{" "}
                {moment(listdata?.SR_NO_DATE).format("DD-MMM-YYYY")}
              </td>
              <td>
                REF INV DATE :{" "}
                {listdata?.REF_DATE
                  ? moment(listdata?.REF_DATE).format("DD-MMM-YYYY")
                  : "NA"}
              </td>

              <td>
                POS :
                {/* {listdata?.B_STATE_NAME ? listdata?.B_STATE_NAME : ""}
              {listdata?.B_STATE_CODE ? `- ${listdata?.B_STATE_CODE}` : ""} */}
                {profile_data.state_name} - {profile_data?.state}
              </td>
            </tr>
            <tr>
              <td style={{ borderBottom: "none" }} colSpan={3}>
                REASON FOR {doc_type == "CN" ? "CREDIT NOTE" : "DEBIT NOTE"} :{" "}
              </td>
            </tr>
          </table>
        ) : doc_type == "DC" ? (
          <table className={styles.table_1}>
            <tr>
              <td colSpan={2}>DC NO. : {listdata?.SR_NO}</td>
              <td colSpan={2}>REF INV NO : {listdata?.REF_NUMBER || "NA"}</td>
              <td colSpan={2}>e-WAYBILL NO :{listdata?.EWAY_NO || "NA"}</td>
              <td colSpan={2}>PO NO :{listdata?.PO_REF || "NA"}</td>
            </tr>
            <tr>
              <td colSpan={2}>
                DC DATE. : {moment(listdata?.SR_NO_DATE).format("DD-MMM-YYYY")}
              </td>
              <td colSpan={2}>
                REF INV DATE :{" "}
                {listdata?.REF_DATE
                  ? moment(listdata?.REF_DATE).format("DD-MMM-YYYY")
                  : "NA"}
              </td>
              <td colSpan={2}>
                e-WAYBILL DATE :{" "}
                {listdata?.EWAY_DATE
                  ? listdata?.EWAY_DATE
                  : "NA"}
              </td>

              <td colSpan={2}>
                PO DATE :{" "}
                {listdata?.PO_REF_DATE
                  ? moment(listdata?.PO_REF_DATE).format("DD-MMM-YYYY")
                  : "NA"}
              </td>
            </tr>

            <tr>
              <td style={{ borderBottom: "none" }} colSpan={4}>
                POS : {profile_data.state_name} - {profile_data?.state}
              </td>
              <td style={{ borderBottom: "none" }} colSpan={2}>
                TRANSPORT MODE : ROAD
              </td>
              <td style={{ borderBottom: "none" }} colSpan={2}>
                DRIVER/SALES MAN NAME: {listdata?.DRIVER_NAME}
              </td>
            </tr>
          </table>
        ) : doc_type == "PO" ? (
          <table className={styles.table_1}>
            <tr>
              <td style={{ borderBottom: "none" }}>
                PO NUMBER : {listdata?.REF_NUMBER || "NA"}
              </td>
              <td style={{ borderBottom: "none" }}>
                PO DATE : {moment(listdata?.REF_DATE).format("DD-MMM-YYYY")}
              </td>
              <td style={{ borderBottom: "none" }}>
                POS : {profile_data.state_name} - {profile_data?.state}
              </td>
            </tr>
          </table>
        ) : doc_type == "QT" ? (
          <table className={styles.table_1}>
            <tr>
              <td style={{ borderBottom: "none" }}>
                QUOTATION NUMBER : {listdata?.SR_NO || "NA"}
              </td>
              <td style={{ borderBottom: "none" }}>
                QUOTATION DATE :{" "}
                {moment(listdata?.SR_NO_DATE).format("DD-MMM-YYYY")}
              </td>
            </tr>
          </table>
        ) : doc_type == "OTV" ? (
          <table className={styles.table_1}>
            <tr>
              <td>INV NO. : {listdata?.SR_NO || "NA"}</td>
              <td>INV REF NO. : {listdata?.REF_NUMBER || "NA"}</td>
            </tr>
            <tr>
              <td>
                INV DATE : {moment(listdata?.SR_NO_DATE).format("DD-MMM-YYYY")}
              </td>
              <td>
                INV REF DATE. :
                {listdata?.REF_DATE
                  ? moment(listdata?.REF_DATE).format("DD-MMM-YYYY")
                  : "NA"}
              </td>
            </tr>
            <tr>
              <td colSpan={3} style={{ borderBottom: "none" }}>
                POS : {profile_data.state_name} - {profile_data?.state}
              </td>
            </tr>
          </table>
        ) : (
          <table className={styles.table_1}>
            <tr>
              <td>INV NO. : {listdata?.SR_NO}</td>
              <td>
                {doc_type == "PDR" ? "REF INV NO. " : "PO NUMBER "} :{" "}
                {listdata?.REF_NUMBER || "NA"}
              </td>
              <td>DC NO : {listdata?.dc_num || "NA"}</td>
            </tr>
            <tr>
              <td>
                INV DATE : {moment(listdata?.SR_NO_DATE).format("DD-MMM-YYYY")}
              </td>
              <td>
                {/* PO DATE : */}
                {doc_type == "PDR" ? "REF INV DATE " : "PO DATE "} :
                {listdata?.REF_DATE
                  ? moment(listdata?.REF_DATE).format("DD-MMM-YYYY")
                  : "NA"}
              </td>

              <td>
                DC DATE :{" "}
                {listdata?.dc_num_date
                  ? moment(listdata?.dc_num_date).format("DD-MMM-YYYY")
                  : "NA"}
              </td>
            </tr>
            {doc_type == "PDR" ? (
              <tr>
                <td colSpan={3} style={{ borderBottom: "none" }}>
                  POS : {profile_data.state_name} - {profile_data?.state}
                </td>
              </tr>
            ) : (
              <tr>
                <td style={{ borderBottom: "none" }}>RCM : YES/NO</td>
                <td style={{ borderBottom: "none" }}>
                  POS : {profile_data.state_name} - {profile_data?.state}
                  {/* {listdata?.B_STATE_NAME ? listdata?.B_STATE_NAME : ""}
            {listdata?.B_STATE_CODE ? `- ${listdata?.B_STATE_CODE}` : ""} */}
                </td>
                <td style={{ borderBottom: "none" }}>
                  E-WAY BILL : {listdata?.eway_bill || "NA"}
                </td>
              </tr>
            )}
          </table>
        )}
        <table>
          {irn && (
            <>
              <tr>
                <td style={{ textAlign: "left" }} colSpan={8}>
                  E-INVOICE IRN NO : {irn}
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    borderBottom: "none",
                  }}
                  colSpan={doc_type == "" ? 4 : 8}
                >
                  IRN DATE : {moment(listdata?.irn_dare).format("DD-MM-YYYY")}
                </td>
                {doc_type == "" && (
                  <td
                    style={{ width: "50%", borderBottom: "none" }}
                    colSpan={4}
                  >
                    E-WAY BILL DATE :{" "}
                    {/* {listdata?.eway_bill_date ? moment(listdata?.eway_bill_date).format("DD-MM-YYYY"):"NA"} */}
                    {listdata?.eway_bill_date ? listdata?.eway_bill_date : "NA"}

                  </td>
                )}
              </tr>
            </>
          )}
        </table>
        <table className={styles.table_1}>
          <tr>
            <td
              colSpan={3}
              style={{
                textAlign: "left",
                borderBottom: "none",
                verticalAlign: "top",
                width: "50%",
              }}
            >
              <div
                style={{
                  flex: 1,
                  gap: ".25rem",
                  flexDirection: "column",
                  display: "flex",
                  alignItems: "flex-start",
                }}
              >
                <div style={{ fontSize: "13px" }}>
                  {doc_type == "PO"
                    ? "VENDOR DETAILS"
                    : doc_type == "QT"
                      ? "CUSTOMER DETAILS"
                      : "BILL TO"}
                </div>

                {listdata?.CVO_NAME && (
                  <div style={{ fontWeight: "bold", fontSize: "13px" }}>
                    {listdata?.CVO_NAME?.toUpperCase()}
                  </div>
                )}
                {listdata?.CVO_NAME == "CASH SALES / HOUSEHOLDS" ||
                  listdata?.CVO_NAME == "UJWALA" ? (
                  ""
                ) : (
                  <>
                    {listdata?.CVO_ADDRESS && (
                      <div
                        style={{
                          wordWrap: "break-word",
                          whiteSpace: "normal",
                          maxWidth: "100%",
                        }}
                      >
                        {listdata.CVO_ADDRESS
                          ? ` ${listdata.CVO_ADDRESS} ,`
                          : ""}
                        {listdata.CVO_LOCATION
                          ? ` ${listdata.CVO_LOCATION} ,`
                          : ""}
                        {listdata.CVO_DISTRICT
                          ? ` ${listdata.CVO_DISTRICT} ,`
                          : ""}
                        {listdata.B_STATE_NAME
                          ? ` ${listdata.B_STATE_NAME} ,`
                          : ""}
                        {listdata.CVO_PINCODE
                          ? ` ${listdata.CVO_PINCODE} `
                          : ""}
                      </div>
                    )}
                    {/* <div>
                    {listdata.CVO_DISTRICT ? `${listdata.CVO_DISTRICT},` : ""}
                    {listdata.B_STATE_NAME ? `${listdata.B_STATE_NAME},` : ""}
                    {listdata.CVO_PINCODE ? `${listdata.CVO_PINCODE},` : ""}
                  </div> */}
                    {/* <div>PH: {listdata?.MOBILE || "NA"}</div>
                  <div>Email: {listdata?.EMAIL || "NA"}</div>
                  <div>State Code : {listdata?.B_STATE_CODE || "NA"}</div>
                  <div>GSTIN/UIN: {listdata?.CVO_TIN || "NA"}</div> */}
                    {/* {listdata?.MOBILE && (
                    <div>PH: {listdata?.MOBILE || "NA"}</div>
                  )} */}
                    {(listdata?.MOBILE || listdata?.EMAIL) && (
                      <div>
                        {" "}
                        {listdata?.MOBILE
                          ? `PH:${listdata?.MOBILE || "NA"}`
                          : ""}{" "}
                        {listdata?.EMAIL
                          ? `Email:${listdata?.EMAIL || "NA"}`
                          : ""}{" "}
                      </div>
                    )}
                    {/* {listdata?.EMAIL  && (
                    <div>Email: {listdata?.EMAIL || "NA"}</div>
                  )} */}
                    {/* {listdata?.B_STATE_CODE && (
                    <div>State Code : {listdata?.B_STATE_CODE || "NA"}</div>
                  )} */}
                    {listdata?.CVO_TIN && (
                      <div>GSTIN/UIN: {listdata?.CVO_TIN || "NA"}</div>
                    )}
                  </>
                )}
              </div>
            </td>
            {ship_to && (
              <td
                colSpan={3}
                style={{
                  textAlign: "left",
                  borderBottom: "none",
                  verticalAlign: "top",
                  width: "50%",
                }}
              >
                <div
                  style={{
                    flex: 1,
                    gap: ".25rem",
                    flexDirection: "column",
                    display: "flex",
                    alignItems: "flex-start",
                  }}
                >
                  <div style={{ fontSize: "13px" }}>SHIP TO</div>

                  {listdata?.SHIP_CVO_NAME && (
                    <div style={{ fontWeight: "bold", fontSize: "13px" }}>
                      {listdata?.SHIP_CVO_NAME.toUpperCase()}
                    </div>
                  )}
                  {listdata?.CVO_NAME == "CASH SALES / HOUSEHOLDS" ||
                    listdata?.CVO_NAME == "UJWALA" ? (
                    ""
                  ) : (
                    <>
                      {listdata?.SHIP_CVO_ADDRESS && (
                        <div
                          style={{
                            wordWrap: "break-word",
                            whiteSpace: "normal",
                            maxWidth: "100%",
                          }}
                        >
                          {listdata.SHIP_CVO_ADDRESS
                            ? ` ${listdata.SHIP_CVO_ADDRESS} ,`
                            : ""}
                          {listdata.SHIP_CVO_LOCATION
                            ? ` ${listdata.SHIP_CVO_LOCATION} ,`
                            : ""}
                          {listdata.SHIP_CVO_DISTRICT
                            ? ` ${listdata.SHIP_CVO_DISTRICT} ,`
                            : ""}
                          {listdata.SHIP_B_STATE_NAME
                            ? ` ${listdata.SHIP_B_STATE_NAME} ,`
                            : ""}
                          {listdata.SHIP_CVO_PINCODE
                            ? ` ${listdata.SHIP_CVO_PINCODE} `
                            : ""}
                        </div>
                      )}
                      {/* <div>
      {listdata.SHIP_CVO_DISTRICT
        ? `${listdata.SHIP_CVO_DISTRICT},`
        : ""}
      {listdata.SHIP_B_STATE_NAME
        ? `${listdata.SHIP_B_STATE_NAME},`
        : ""}
      {listdata.SHIP_CVO_PINCODE
        ? `${listdata.SHIP_CVO_PINCODE},`
        : ""}
    </div> */}
                      {/* {listdata?.MOBILE && (
      <div>PH: {listdata?.MOBILE || "NA"}</div>
    )}
    {listdata?.EMAIL && (
      <div>Email: {listdata?.EMAIL || "NA"}</div>
    )} */}
                      {(listdata?.MOBILE || listdata?.EMAIL) && (
                        <div>
                          {" "}
                          {listdata?.MOBILE
                            ? `PH:${listdata?.MOBILE || "NA"}`
                            : ""}{" "}
                          {listdata?.EMAIL
                            ? `Email:${listdata?.EMAIL || "NA"}`
                            : ""}{" "}
                        </div>
                      )}
                      {/* {listdata?.SHIP_B_STATE && (
      <div>State Code : {listdata?.SHIP_B_STATE || "NA"}</div>
    )} */}
                      {listdata?.CVO_TIN && (
                        <div>GSTIN/UIN: {listdata?.CVO_TIN || "NA"}</div>
                      )}
                    </>
                  )}
                </div>
              </td>
            )}
          </tr>
        </table>
        <table>
          {table_header ? (
            table_header
          ) : (
            <tr>
              <td> SL NO</td>
              <td> ITEM DESCRIPTION</td>
              <td> HSN</td>
              <td>QTY </td>
              <td> RATE / UNIT</td>
              <td>DISC / UNIT </td>
              <td>GST </td>
              <td style={{ textAlign: "right" }}> AMOUNT</td>
            </tr>
          )}

          {table_body}
          <tr
            style={{
              height: `${empty_row_height < 0 ? 0 : empty_row_height}px`,
            }}
          >
            {Array(empty_arr_length)
              .fill()
              .map((v, i) => (
                <td key={i} className="both"></td>
              ))}
          </tr>
        </table>
        {other_data}
        {/* Same in All  */}
        <table>
          {doc_type == "DC" ? (
            <>
              <tr>
                <td
                  rowSpan={7}
                  colSpan={5}
                  style={{
                    width: "40%",
                    textAlign: "center",
                    verticalAlign: "top",
                    borderBottom: "none",
                  }}
                >
                  RECEIPIENT STAMP & SIGNATURE
                </td>
                <td
                  style={{
                    width: "25%",
                  }}
                >
                  ITEM RECEIVED BY
                </td>
                <td colSpan={2}></td>
              </tr>
              <tr>
                <td
                  style={{
                    width: "25%",
                  }}
                >
                  MOB NO
                </td>
                <td colSpan={2}></td>
              </tr>
              <tr>
                <td
                  style={{
                    width: "25%",
                  }}
                >
                  RECEIPT DATE & TIME
                </td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td
                  style={{
                    height: "100px",
                    textAlign: "center",
                    verticalAlign: "top",
                    borderBottom: "none",
                  }}
                  rowSpan={4}
                  colSpan={3}
                >
                  GATE ENTRY DETAILS:
                </td>
              </tr>
            </>
          ) : (
            <>
              <tr>
                <td colSpan={5}>
                  {doc_type == "OTV"
                    ? "TOTAL REFUND AMOUNT:"
                    : "TOTAL INV AMOUNT:"}
                  <span style={{ fontWeight: "bold" }}>
                    {convertAmountToWords}
                  </span>
                </td>
                <td>AMOUNT BEFORE TAX</td>
                <td style={{ textAlign: "right" }}>{taxable_amt}</td>
              </tr>
              {doc_type == "CN" ||
                doc_type == "DN" ||
                doc_type == "PO" ||
                doc_type == "QT" ? (
                <>
                  <tr>
                    <td
                      colSpan={5}
                      rowSpan={7}
                      style={{ verticalAlign: "baseline" }}
                    >
                      {doc_type == "QT" ? (
                        <>TERMS OF SUPPLY: {listdata?.TERMS}</>
                      ) : (
                        ""
                      )}
                    </td>
                    <td>IGST</td>
                    <td style={{ textAlign: "right" }}>{igst}</td>
                  </tr>

                  <tr>
                    <td>CGST</td>
                    <td style={{ textAlign: "right" }}>{cgst}</td>
                  </tr>
                  <tr>
                    <td>SGST</td>
                    <td style={{ textAlign: "right" }}>{sgst}</td>
                  </tr>

                  <tr>
                    <td>TOTA GST</td>
                    <td style={{ textAlign: "right" }}>{Total_tax}</td>
                  </tr>
                  <tr>
                    <td>ADDITIONAL CHARGES</td>
                    <td style={{ textAlign: "right" }}>{other}</td>
                  </tr>
                  <tr>
                    <td>TOTAL INV AMOUNT</td>
                    <td style={{ textAlign: "right" }}>{net_total}</td>
                  </tr>

                  <tr>
                    <td>ROUNDED OFF</td>
                    <td style={{ textAlign: "right" }}>
                      {(
                        Number(net_total).toFixed(0) - Number(net_total)
                      ).toFixed(2)}
                    </td>
                  </tr>
                </>
              ) : (
                <>
                  <tr>
                    <td
                      colSpan={1}
                      rowSpan={6}
                      style={{
                        textAlign: "center",
                        width: !bank ? "250px" : "auto", // Set the max width for the td
                        overflow: "hidden", // Ensure content does not overflow
                      }}
                    >
                      {upi_qr_image && (
                        <img
                          id="Aname"
                          style={{
                            width: "100%", // Make sure the image fits within the td's width
                            height: "auto", // Keep the aspect ratio of the image
                            maxWidth: "100px", // Set a max width for the image if needed
                            maxHeight: "100px", // Set a max height for the image
                          }}
                          src={upi_qr_image}
                        />
                      )}
                    </td>
                    {!bank ? (
                      <td
                        colSpan={4}
                        rowSpan={7}
                        style={{
                          verticalAlign: "top",
                          textAlign: "left",
                          width: "200px",
                        }}
                      >
                        TERMS OF SUPPLY: {listdata?.TERMS}
                      </td>
                    ) : (
                      <td colSpan={4}>
                        OUR BANK ACCOUNT NO : <b>{bank_data[0]?.BANK_ACC_NO}</b>
                      </td>
                    )}

                    <td>IGST</td>
                    <td style={{ textAlign: "right" }}>{igst}</td>
                  </tr>
                  <tr>
                    {bank && (
                      <td colSpan={4}>
                        IFSC CODE : <b>{bank_data[0]?.BANK_IFSC_CODE}</b>
                      </td>
                    )}

                    <td>CGST</td>
                    <td style={{ textAlign: "right" }}>{cgst}</td>
                  </tr>
                  <tr>
                    {bank && (
                      <td colSpan={4}>
                        BANK/BRANCH : <b>{bank_data[0]?.BANK_BRANCH}</b>
                      </td>
                    )}

                    <td>SGST</td>
                    <td style={{ textAlign: "right" }}>{sgst}</td>
                  </tr>
                  <tr>
                    {bank && (
                      <td
                        colSpan={4}
                        rowSpan={4}
                        style={{ verticalAlign: "top", textAlign: "left" }}
                      >
                        TERMS OF SUPPLY:
                      </td>
                    )}
                    <td>TOTA GST</td>
                    <td style={{ textAlign: "right" }}>{Total_tax}</td>
                  </tr>
                  <tr>
                    <td>
                      {doc_type == "NC" || doc_type == "OTV"
                        ? "SECURITY DEPOSIT"
                        : "ADDITIONAL CHARGES"}
                    </td>
                    <td style={{ textAlign: "right" }}>{other}</td>
                  </tr>
                  <tr>
                    <td>
                      {doc_type == "OTV"
                        ? "TOTAL REFUND AMOUNT"
                        : "TOTAL INV AMOUNT"}
                    </td>
                    <td style={{ textAlign: "right" }}>{net_total}</td>
                  </tr>
                  <tr>
                    <td>
                      UPI ID : <b>{upi_id}</b>
                    </td>
                    <td>ROUNDED OFF</td>
                    <td style={{ textAlign: "right" }}>
                      {(
                        Number(net_total).toFixed(0) - Number(net_total)
                      ).toFixed(2)}
                    </td>
                  </tr>
                </>
              )}
            </>
          )}
        </table>
        <table>
          <tr>
            <td
              colSpan={5}
              rowSpan={4}
              style={{
                verticalAlign: "center",
                textAlign: "left",
                // borderTop: "none",
              }}
            >
              DECLARATION: THIS IS THE SYSTEM GENERATED INVOICE AND WE DECLARE
              THAT THIS INVOICE SHOWS THE ACTUAL PRICE OF THE GOODS DESCRIBED
              AND THAT ALL PARTICULARS ARE TRUE AND CORRECT
            </td>
            <td
              colSpan={3}
              style={{
                textAlign: "left",
                fontSize: "14px",
                // borderTop: "none"
              }}
            >
              <b>For: {profile_data?.name} </b>
            </td>
          </tr>
          <tr>
            <td
              colSpan={3}
              rowSpan={1}
              style={{
                height: "60px",
                verticalAlign: "center",
                textAlign: "center",
              }}
            >
              {seal_image && signature_image && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "transparent"
                  }}
                >
                  <img
                    src={seal_image}
                    alt=""
                    style={{
                      height: "60px",
                      width: "60px",
                      zIndex: 1,
                      mixBlendMode: "multiply",
                      backgroundColor: "transparent",
                      opacity: 0.92,
                      filter: "contrast(1.25) brightness(1.08) saturate(0.9)",
                    }}
                  />
                  <img
                    src={signature_image}
                    alt=""
                    style={{
                      height: "60px",
                      width: "60px",
                      marginLeft: "-10px",
                      zIndex: 2,
                      mixBlendMode: "multiply",
                      opacity: 0.92,
                      filter: "contrast(1.25) brightness(1.08) saturate(0.9)",
                      backgroundColor: "transparent",
                    }}
                  />
                </div>
              )}
            </td>
          </tr>
          <tr>
            <td colSpan={3} style={{ textAlign: "left" }}>
              AUTHORISED SIGNATORY
            </td>
          </tr>
        </table>
      </div>
    );
  }
);

export default TaxInvoice3;
